import { inject, Injectable } from '@angular/core';
import { User as ConfigCatUser } from 'configcat-common';
import { map, take } from 'rxjs/operators';
import { ConfigCatUserContextProvider } from '@feature-flags/config-cat/config-cat-user-context';
import { ActiveSecurityContextStateService } from './active-security-context.state-service';

/**
 * Main-app ConfigCat user context: identity is read live from the active
 * security context, and the context is considered known once the first
 * active membership resolves after sign-in.
 */
@Injectable({ providedIn: 'root' })
export class ActiveSecurityConfigCatUserContextProvider implements ConfigCatUserContextProvider {
  private readonly activeSecurity = inject(ActiveSecurityContextStateService);

  readonly userContextLoaded$ = this.activeSecurity.activeMembership$.pipe(
    take(1),
    map(() => undefined as void)
  );

  getUserContext(): ConfigCatUser {
    const userEmail = this.activeSecurity.activeUser?.email || 'NOT SET';
    const userDomain = userEmail.split('@').pop();

    return {
      identifier: this.activeSecurity.activeUser?.id,
      email: userEmail,
      custom: {
        domain: userDomain,
        OrganisationName: this.activeSecurity.activeMembership?.organisationName ?? 'NOT SET',
        BureauName: this.activeSecurity.activeMembership?.bureauProfile?.name ?? 'NOT SET'
      }
    };
  }
}
